<template>
  <div>
    <div class="mw-toolbar" v-if="buttons.length>0" ref="buttonsContainer">
      <el-button size="small" type="primary" :key="button.id" :id="button.id" v-for="button in buttons">
        {{button.name}}
      </el-button>
    </div>
    <div class="mw-toolbar__body" ref="iframeContainer">
    </div>
  </div>
</template>

<script>
  import NtkoOffice from "./src/ntko-func-extend";

  /**
   * 文档执行的相关函数说明
   * init() 获取参数
   * initIframe() 初始化控件iframe
   * removeIframe()
   *
   */
  export default {
    name: "mw-ntko-editor",
    data() {
      let me = this;
      return {
        path: $WR.DOC_CTRL_URL_BASE,
        buttons: me.defButtons,
        editor: {}
      };
    },
    created() {
    },
    props: {
      params: {type: Object},
      defButtons: {
        default: function () {
          return [];
        },
        type: Array
      },
      getForm:{
        default:function () {
          return {};
        }
      },
      propObject: {
        default: function () {
          return {};
        },
        type: Object
      }
    },
    beforeDestroy() {
      var me = this;
      if (me.ofc) {
        me.ofc.destroy();
      }
      me.ofc = null;
      if (this.ownerCt) {
        this.ownerCt.destroy();
      }
      return;
    },
    mounted() {
      let me = this;
      debugger
      me.initOfc();
      me.initButtonsEvents();
      me.$nextTick(function () {
        me.initIframe(me);
      });
    },
    methods: {
      getForm: function () {
        return this.propObject.getForm?this.propObject.getForm():null;
      },
      removeIframe: function () {
        if (me.ofc) {
          me.ofc.destroy();
        }
      },
      /**
       * 初始化参数
       */
      initOfc: function () {
        var me = this;
        var loc = window.location;
        var portStr = "";
        if (loc.port != 80) {
          portStr = ":" + loc.port;
        }
        me.windowHref = loc.protocol + "//" + loc.hostname + portStr //+ loc.pathname;
        var cfg = me.propObject;
        if (cfg) {
          me.cfg = cfg;
          me.formData = cfg.formData;
          // me.getForm() = cfg.form;
          var form=me.getForm();
          if (form && $.isFunction(form.getValue)) {
            try {
              me.formData = form.getValue();
            } catch (e) {
              me.formData = cfg.formData;
            }
          }
        }
        me.ofc = new NtkoOffice();
        me.ofc.form = me.getForm();
        me.ofc.renderTo = ".mw-toolbar__body";
        me.ofc.scope = me.$el;
        me.ofc.downloadUrl = me.windowHref + me.mwUrl('/api/business/downloadAttachment'); //下载附件url
        me.ofc.uploadUrl = me.windowHref + me.mwUrl('/api/business/uploadAttachment');//上传 附件
        me.ofc.updateUrl = me.windowHref + me.mwUrl('/api/business/updateAttachment');//更新附件
        me.ofc.pluginUrl = me.windowHref + "/assets/ntkooledocall/ntkooledocall.cab";//插件路径
        me.ofc.ocxPath = me.windowHref + "/assets/ntkooledocall/OfficeControl.cab#version=5,0,4,0";//控件url

        var fieldMap = me.propObject.params.formConfig ? me.propObject.params.formConfig.fieldMap : [];
        if (fieldMap && fieldMap.length > 0) {
          $.each(fieldMap, function (index, el) {
            me.ofc[el.field] = el.props;
          })
        }

        if (me.getForm() && me.getForm().on) {
          me.getForm().on("beforesave", function () {
            var action = me.ofc["BEFORE_FORM_SAVE"] || "ntko_before_form_save_action";
            if (PF.action && PF.action[action]) {
              return PF.action[action].call(me.getForm(), me.ofc);
            } else {
              try {
                var efileType = me.ofc.efileType;
                if ((efileType == "JOA_CG" || efileType == "JOA_HG" || efileType == "JOA_ZW") && me.ofc && me.ofc.isWord() && !me.ofc.isSaved() && !me.ofc.readOnly && me.ofc.getProtectType() != me.ofc.ProtectMode.READONLY) {
                  var flag = me.ofc.saveDocumentToServer();
                  if (!flag) {
                    alert("正文保存失败");
                  }
                  return flag;
                }
              } catch (e) {
              }
            }
          })
          var componentTag = me.propObject.componentTag;
          if (componentTag != "CreateCLD" && componentTag != "OnLineEfileEdit"&&me.getForm()) {
            me.getForm().getOFC = function () {
              return me.ofc;
            }
          }
        }
      },
      //初始化iframe
      initIframe: function () {
        var me = this;
        if (me.propObject.params.fileUrl && me.propObject.componentTag == "OnLineEfileEdit") {//附件url直接打开
          var fName = me.propObject.params.fileName;
          me.ofc.fileName = fName;
          if (me.ofc.getFileType() == ".ofd") {
            me.ofc.tpl = me.ofc.getOfdTpl();
            me.ofc.on("load", function () {
              me.ofc.openOfdDocument(me.propObject.params.fileUrl);
            });
            me.ofc.render(".mw-toolbar__body", me.$el);
            return;
          }
          me.ofc.on("load", function () {//渲染完成之后打开附件
            var isOpen = me.ofc.openFromUrl(me.propObject.params.fileUrl);
            if (isOpen) {
              if (me.propObject.afterDocOpen) {
                me.propObject.afterDocOpen.call(me, me.ofc);
                return;
              }
              if (me.ofc.getProduct() == me.ofc.ProductType.NTKO_OFFICE) {
                me.ofc.showTitleBar(false);
                if (me.ofc.isWord()) {
                  me.ofc.showToolBars(false);
                  me.ofc.showRevisions(false);
                }
                me.ofc.protect(me.ofc.ProtectMode.READONLY);//附件只读
              }
            } else {
              alert("文件打开失败")
            }
          });
          me.ofc.render(".mw-toolbar__body", me.$el);
          return;
        }
        //正文
        me.Load(function (file) {//查询要打开的附件
          if (!file || !file.id) return;
          //ofd文件
          if (file.mimeType == ".ofd") {
            me.ofc.tpl = me.ofc.getOfdTpl();
            me.ofc.on("load", function () {
              me.ofc.efileType = file.efileType;
              me.ofc.fileName = file.name || "zw.ofd";
              me.ofc.saveParams = {
                fileId: file.id,
                businessId: file.businessId,
                tempBusinessId: file.tempBusinessId,
                formId: file.formId,
                attachId: file.id
              }
              me.ofc.openOfdDocument({
                fileId: file.id,
                businessId: file.businessId,
                tempBusinessId: file.tempBusinessId,
                formId: file.formId
              });
            });
            me.ofc.render(".mw-toolbar__body", me.$el);
            return;
          } else {
            if (me.ofc.getFileType() == ".ofd") {
              me.ofc.tpl = null;
            }
          }
          //图片
          if ($.inArray(file.mimeType, [".png", ".jpg", ".jpeg", ".gif", ".bmp"]) != -1) {
            var imgUrl = me.ofc.downloadUrl + "?" + $.param({
              id: file.id,
              businessId: file.businessId,
              tempBusinessId: file.tempBusinessId,
              formId: file.formId
            });
            me.ofc.fileName = file.name;
            me.ofc.tpl = `<img src='${imgUrl}'/>`;
            me.ofc.render(".mw-toolbar__body", me.$el);
            return;
          }
          me.ofc.on("load", function () {//渲染完成之后打开附件
            var action = me.ofc["OPEN_ACTION"] || "ntko_open_action";
            if (PF.action && PF.action[action]) {
              try {
                var flag = PF.action[action](me.getForm(), me.ofc, file);
                if (flag === true) {
                  return;
                }
              } catch (e) {
              }
            }
            try {
              me.openDocument(file);
            } catch (e) {
              alert(e);
            }
            var action = me.ofc["AFTER_OPEN_ACTION"] || "ntko_after_open_action";
            if (PF.action && PF.action[action]) {
              try {
                var flag = PF.action[action](me.getForm(), me.ofc);
                if (flag === true) {
                  return;
                }
              } catch (e) {
              }
            }
          });
          me.ofc.tpl = null;
          me.ofc.render(".mw-toolbar__body", me.$el);//渲染到指定元素
        });
      },
      /**
       * 打开文档
       * @param file {object} {name:"",id:"",efileType:"",businessId:"",tempBusinessId:"",formId:""}
       */
      openDocument: function (file) {
        var me = this;
        var tempBusinessId = file.tempBusinessId;
        var businessId = file.businessId;
        var formId = file.formId;
        var linkId = file.id;
        var efileType = file.efileType;
        var fileName = file.name ? file.name : ((me.propObject.formData ? me.propObject.formData["fldtm"] || "正文" : "正文") + ".doc")
        var isReadOnly = me.propObject.isReadOnly || false;
        me.ofc.docFormatObject = me.propObject.docFormatObject;
        me.ofc.formData = me.formData;
        me.ofc.openParams = {
          tempBusinessId: tempBusinessId,
          formId: formId,
          businessId: businessId
        };
        me.ofc.saveParams = {
          tempBusinessId: me.propObject.params.tempBusinessId,
          formId: me.propObject.params.formId,
          businessId: me.propObject.params.businessId
        };

        me.ofc.fileId = linkId;
        me.ofc.fileLinkId = file.saveNew ? null : linkId;//有这个值,则是保存,没有则是另存;
        me.ofc.setFileName(fileName);          //文件名(保存,另存为)
        me.ofc.fileType = me.ofc.getFileType(); //后缀 .doc/.wps/...
        me.ofc.userName = me.propObject.params.userName;
        me.ofc.efileType = efileType;
        me.ofc.pkId = businessId;
        if (!linkId) {//如果不存在，就新建一个空文档
          me.ofc.createNew();
        } else {
          var isOpened = me.ofc.openDocument();//打开文件(同步方式)
          if (!isOpened) {
            alert("文件打开失败");
            return;
          }
        }
        me.ofc.setUserName();
        if (me.ofc.efileType == me.getEFileTypes().CG) {//草稿记录修订
          me.ofc.trackRevisions(true);
        }
        me.ofc.showRevisions(false);//默认不显示修订
        me.ofc.showTitleBar(false);//标题栏不显示

        if ((efileType == "JOA_CLD" || efileType == "JOA_CG" || me.ofc.isSetBookMarkValue) && !isReadOnly) {
          var formData = me.getForm() && me.getForm().getValue ? me.getForm().getValue() : me.formData;
          me.ofc.setLabelValue(me.propObject.docFormatObject, formData, me.propObject.params.businessId, me.propObject.params.processDefinitionId);
        }
        if ((efileType == "JOA_ZW" || efileType == "JOA_CG") && me.ofc.isWord() && !isReadOnly && !me.ofc.readOnly) {
          me.ofc.setAutoSave();
        }
        if ((me.ofc.isWord() || me.ofc.isExcel()) && (isReadOnly || me.ofc.readOnly)) {//doc,excel 只读加保护
          me.ofc.showToolBars(false);
          me.ofc.setSaved(true);
          me.ofc.protect(me.ofc.ProtectMode.READONLY);
        }
        me.ofc.isOpened = true;
      },
      getEFileTypes() {
        return {
          ZW: "JOA_ZW",
          CG: "JOA_CG",
          FJ: "JOA_FJ",
          HG: "JOA_HG",
          PDF: "JOA_PDF",
          CLD: "JOA_CLD",
        }
      },
      getOpenFile: function (efileList) {
        efileList = efileList || [];
        let me = this;
        var cfg = me.cfg;
        var isReadOnly = me.propObject.isReadOnly || false;
        let linkId = "";
        var types = me.getEFileTypes();

        //发文格式的配置信息，包括模板信息都写在me.docFormatObject中
        me.wordTplFileLinkId = me.propObject.params.efileType == types.CLD ? cfg.docFormatObject.cldMouldId : cfg.docFormatObject.caoGaoMouldId;   //配置处理单对应模板id
        me.headFileLinkId = cfg.docFormatObject.headMouldId;      //模板头id
        me.endFilelinkId = cfg.docFormatObject.tailMouldId;       //模板尾id
        me.tmplListObject = cfg.docFormatObject.tmplListObject;  //模板书签对象
        let isOpenMoudle = false;
        var cg, zwdoc, hg, cld, zwpdf, zwofd, zwimg;

        var efileType = me.propObject.params.efileType;

        function getMimeType(item) {
          if (item.mimeType == ".doc" || item.mimeType == ".docx" || item.mimeType == ".wps") {
            return ".doc";
          }
          return item.mimeType;
        }

        var types = me.getEFileTypes();

        for (var i = 0; i < efileList.length; i++) {
          var item = efileList[i];
          var mimeType = getMimeType(item);
          if (item.type == types.ZW || item.type == types.PDF) {
            if (mimeType == ".doc") {
              zwdoc = item;
            } else if (mimeType == ".pdf") {
              zwpdf = item;
            } else if (mimeType == ".ofd") {
              zwofd = item;
            } else if ($.inArray(mimeType, [".png", ".jpg", ".jpeg", ".gif", ".bmp"]) != -1) {
              zwimg = item;
            }
          } else if (item.type == types.HG) {
            hg = item;
          } else if (item.type == types.CG) {
            cg = item;
          } else if (item.type == types.CLD) {
            cld = item;
          }
        }
        var openFile;
        var businessId = me.propObject.params.businessId;
        var formId = me.propObject.params.formId;
        var tempBusinessId = me.propObject.params.tempBusinessId;

        if (efileType == types.CLD && me.propObject.componentTag != "CreateCLD") {
          openFile = cld;
        } else if (efileType == types.ZW) {
          openFile = isReadOnly ? (zwofd || zwpdf || zwdoc || cg || zwimg) : (zwdoc || cg || zwofd || zwpdf || zwimg);
        } else if (efileType == types.CG) {
          openFile = cg;
        }
        var saveNew = false;
        if (!openFile) {
          linkId = me.wordTplFileLinkId;
          formId = me.propObject.docFormatObject.mouldFormId;
          if (efileType != types.CLD) {
            efileType = types.CG;
            businessId = me.propObject.docFormatObject.caoGaoDocId;
          } else {
            businessId = me.propObject.docFormatObject.cldDocId;
          }
          tempBusinessId = "";
          saveNew = true;
        }
        return {
          tempBusinessId: tempBusinessId,
          formId: formId,
          saveNew: saveNew,
          businessId: businessId,
          mimeType: openFile ? openFile.mimeType : "",
          id: openFile ? openFile.id : linkId,
          efileType: openFile ? openFile.type : efileType,
          name: openFile ? openFile.name : "",
        };
      },
      _log: function (msg) {
        // if (window.console.log) {
        //   console.log(msg);
        // }
      },
      Load(callback) {
        let me = this;
        var cfg = me.cfg;
        let params = {};
        params.businessId = me.propObject.params.businessId;
        params.formId = me.propObject.params.formId;
        params.tempBusinessId = me.propObject.params.tempBusinessId;
        //找附件正文打开优先级别为 正文/草稿/模板
        params.type = me.propObject.params.efileType == "JOA_CLD" ? "JOA_CLD" : "JOA_CG,JOA_HG,JOA_ZW,JOA_PDF";
        me.mwApi.business.listAttachment(params).then(r => {
          var fileList = r.result;
          var file = me.getOpenFile(fileList);
          me._log("open file ==> " + JSON.stringify(file))
          if (callback) {
            callback.call(me, file);
          }
        })
      },
      initButtonsEvents() {
        var me = this;
        if (me.buttons) {
          $.each(me.buttons, function (i, btn) {
            if (btn.handler) {
              $("#" + btn.id, me.$el).click(function () {
                btn.handler.call(me, me.ofc);
              })
            }
          })
        }
        $("#save").click(function () {
          var efileType = me.ofc.efileType || me.propObject.params.efileType;
          var p = {
            businessId: me.propObject.params.businessId,
            tempBusinessId: me.propObject.params.tempBusinessId,
            formId: me.propObject.params.formId,
            type: efileType
          }
          var isCheck = false;
          if (efileType == "JOA_CG" || efileType == 'JOA_ZW' || efileType == "JOA_CLD") {
            isCheck = true;
          }
          MW.mwApi.business.listAttachment(p).then(function (res) {
            var fileLinkId;
            if (res && res.result && res.result.length > 0) {
              $.each(res.result, function (idex, el) {
                if (el.mimeType == ".doc" || el.mimeType == ".docx" || el.mimeType == ".wps") {
                  fileLinkId = el.id;
                }
              })
            }
            if (isCheck && fileLinkId) {
              p.attachId = fileLinkId;
            } else if (!isCheck) {
              p.attachId = me.ofc.fileId;
            }

            var res = me.ofc.saveDocument(p);
            var ret = JSON.parse(res);
            if (ret.success && ret.result) {
              alert("保存成功");
            }
          })
        })
        $("#print").click(function () {
          if (me.ofc) {
            me.ofc.printOut();
          }
        })
      },
      noticeButtonEvent(name) {
        let me = this;
        return;
      }
      ,
      closeIframe() {
        var me = this;
        // me.NtkoOffice.closeIframe();
      },
      downLoadAttach(data) {
        let params = {}
        params.id = data.id;
        params.businessId = this.propObject.params.businessId;
        params.formId = this.propObject.params.formId;
        params.tempBusinessId = this.propObject.params.tempBusinessId;
        return this.mwApi.business.downloadAttachment(params, false);
      }
      ,
      listAttachment(data) {
        let params = {}
        params.businessId = this.propObject.params.businessId;
        params.formId = this.propObject.params.formId;
        params.tempBusinessId = this.propObject.params.tempBusinessId;
        return this.mwApi.business.listAttachment(params);
      }
      ,
      getDict(dict) {
        // 根据id的值获取到数据字典
        this.mwApi.data.getDict(dict).then(function (data) {
          return data;
        });
      },
      getDictByCode(dictcode) {
        // 根据code的值获取到数据字典
        this.mwApi.data.getDictByCode(dictcode).then(v => console.log(v)).catch(err => console.log(err));
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/common/components/extend/ntko/ntko-editor.vue